export const ROUTES = {
  initializing: "initializing",
  dashboard: "dashboard",
  login: "login",
  appointments: "appointments",
  appointmentDetails: "appointments/:id",
  patients: "patients",
  billings: "billings",
  guardians: "guardians",
  settings: "settings",
  inventory: "inventory",
  suppliers: "suppliers",
  schedule: "schedule",
  smsMessages: "sms-messages",
  logs: "logs",
  unauthorizedAccess: "no-access",
};
